import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7a8c092a")

_pushScopeId("data-v-7a8c092a")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "logo" }, "Sparing Timer", -1)
const _hoisted_4 = {
  key: 0,
  class: "local-login"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "subtitle" }, "Local development login", -1)
const _hoisted_6 = { class: "user-name" }
const _hoisted_7 = { class: "user-role" }
const _hoisted_8 = {
  key: 0,
  class: "error-message"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: "/img/btn_google_signin_light_normal_web@2x.png",
  alt: "Sign in with Google",
  class: "login-img"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isLocalLoginEnabled)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _hoisted_5,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
              return (_openBlock(), _createBlock("button", {
                key: user.id,
                class: "user-btn",
                disabled: _ctx.isLoading,
                onClick: ($event: any) => (_ctx.loginAsUser(user.id))
              }, [
                (user.picture)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: user.picture,
                      alt: `${user.firstName} ${user.lastName}`,
                      class: "avatar"
                    }, null, 8, ["src", "alt"]))
                  : _createCommentVNode("", true),
                _createVNode("span", _hoisted_6, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1),
                _createVNode("span", _hoisted_7, _toDisplayString(user.role), 1)
              ], 8, ["disabled", "onClick"]))
            }), 128)),
            (_ctx.errorMessage)
              ? (_openBlock(), _createBlock("p", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createBlock("a", {
            key: 1,
            class: "login-btn",
            href: _ctx.googleAuthUrl
          }, [
            _hoisted_9
          ], 8, ["href"]))
    ])
  ]))
})